export enum NavMenuItemKeys {
  Home = 'home',
  Apps = 'apps',
  Tools = 'tools',
  Changelogs = 'changelogs',
  Bots = 'bots',
  Help = 'help',
}

export interface INavigationGroup {
  content: string;
  getIcon: (active: boolean) => React.ReactElement;
  route: string;
  key: NavMenuItemKeys;
  id: string;
}

export const Routes = {
  Home: `/home`,
  Auth: `/auth`,
  Apps: `/apps`,
  Bots: `/bots`,
  Validation: `/validation`,
  Cards: `/cards`,
  Identity: `/identity`,
  Tools: `/tools`,
  Changelog: `/changelog`,
  ApiKeyRegistration: `/api-key-registration`,
  OAuthConfiguration: `/oauth-configuration`,
  EntraConfiguration: `/entra-configuration`,
};

export const getSelectedKey = (path: string) => {
  const pathToMatch = `/${path.split('/')[1]}`;
  switch (pathToMatch) {
    case Routes.Apps:
      return NavMenuItemKeys.Apps;
    case Routes.Bots:
      return NavMenuItemKeys.Bots;
    case Routes.Cards:
    // case Routes.Scenes:
    case Routes.Identity:
    case Routes.Tools:
    case Routes.OAuthConfiguration:
    case Routes.EntraConfiguration:
    case Routes.ApiKeyRegistration:
    case Routes.Validation:
      return NavMenuItemKeys.Tools;
    case Routes.Changelog:
      return NavMenuItemKeys.Changelogs;
    default:
    case Routes.Home:
      return NavMenuItemKeys.Home;
  }
};
